import {
    Expert,
    ExpertCertificate,
    IApplicantQualification,
    ExamList,
    FilteredExamStatus,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import moment from 'moment';

const initialState: IState = {
    personalData: null,
    certificateList: null,
    qualificationsList: null,
    examsList: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setPersonalData(state, personalData: Expert | null) {
            return { ...state, personalData };
        },
        setCertificateList(state, certificateList: ExpertCertificate | null) {
            return { ...state, certificateList };
        },
        setQualificationsList(state, qualificationsList: IApplicantQualification[] | null) {
            return { ...state, qualificationsList };
        },
        setExamsList(state, examsList: ExamList | null) {
            return { ...state, examsList };
        },
        clearState() {
            return {
                ...initialState,
            };
        },
    },
    effects: (dispatch: any) => ({
        /* Person */
        async getPersonalDataAsync(expertId: string) {
            this.setPersonalData(null);

            const personalData = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpert(expertId));

            this.setPersonalData(personalData);
        },
        /* Certificate */
        async getCertificateListAsync(expertId: string) {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertCertificates(expertId));

            this.setCertificateList(certificateList);
        },
        /* Qualifications */
        async getQualificationsListAsync(expertId: string) {
            const qualificationsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertQualifications(expertId));

            this.setQualificationsList(qualificationsList);
        },
        /* Exams */
        async getExamsListAsync({
            expertId, page, pageSize, sortOrder, sortField, from, to, filteredExamStatus,
        }: IGetExamsListProps) {
            const examsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertExams(
                expertId,
                undefined,
                undefined,
                filteredExamStatus,
                from,
                to,
                page,
                pageSize,
                sortOrder,
                sortField,
            ));

            this.setExamsList(examsList);
        },
        /* Clear state */
        clearExpertState() {
            this.clearState();
        },
    }),
});

interface IGetExamsListProps {
    expertId: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
    from?: moment.Moment;
    to?: moment.Moment;
    filteredExamStatus?: FilteredExamStatus;
}

interface IState {
    personalData: Expert | null;
    certificateList: ExpertCertificate[] | null;
    qualificationsList: IApplicantQualification[] | null;
    examsList: ExamList | null;
}
